import { ReactNode } from 'react'
import { Box, Card, CardContent, Typography } from '@mui/material'

interface ProfileSectionProps {
  title: string
  icon?: ReactNode
  action?: ReactNode
  children: ReactNode
}

/** A titled card used by both the profile read views and the single-page edit forms. */
export const ProfileSection = ({ title, icon, action, children }: ProfileSectionProps) => (
  <Card>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {icon}
          {title}
        </Typography>
        {action}
      </Box>
      {children}
    </CardContent>
  </Card>
)
